// src/components/TermosDeUso.tsx
import styled from "styled-components";
import { useAppSelector } from "../../store/hooks";
import { useState } from "react";
import { LocaSmartLayout } from "../../components/locasmart-layout";

const TermosContainer = styled.div`
  max-width: 800px;
  margin: 40px auto;
  padding: 20px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  line-height: 1.6;
  color: #333;

  h1 {
    color: #1F467E;
    font-size: 2rem;
    margin-bottom: 20px;
  }

  h2 {
    font-size: 1.5rem;
    margin-top: 20px;
    margin-bottom: 10px;
    color: #1F467E;
  }

  p {
    margin-bottom: 15px;
    font-size: 1rem;
    color: #6c757d;
  }

  ul {
    margin-bottom: 15px;
    padding-left: 20px;
  }

  li {
    margin-bottom: 10px;
    font-size: 1rem;
    color: #6c757d;
  }
`;

function TermosDeUso() {
  const [logado] = useState<boolean>(useAppSelector(state => state.logado));

  return (

    logado ? <>
      <LocaSmartLayout>
        <TermosContainer>
          <h1>Termos de Uso - LocaSmart Pro</h1>
          <p><strong>Última atualização: 26 de abril de 2025</strong></p>
          <p>Bem-vindo ao LocaSmart Pro, uma plataforma de gerenciamento inteligente de locações de veículos. Ao utilizar nossos serviços, você concorda em cumprir e estar vinculado aos seguintes Termos de Uso. Leia atentamente antes de se cadastrar ou utilizar a plataforma.</p>

          <h2>1. Aceitação dos Termos</h2>
          <p>Ao acessar ou utilizar o LocaSmart Pro, você declara que leu, entendeu e concorda em cumprir estes Termos de Uso, bem como nossa Política de Privacidade. Se você não concordar com qualquer parte destes termos, não poderá utilizar nossos serviços.</p>

          <h2>2. Descrição do Serviço</h2>
          <p>O LocaSmart Pro é uma plataforma que oferece ferramentas para gerenciamento de locações de veículos, incluindo cadastro de clientes, controle de contratos, faturamento e relatórios. O serviço é destinado a empresas e indivíduos que gerenciam locações de veículos, sujeito às condições aqui estabelecidas.</p>

          <h2>3. Elegibilidade</h2>
          <p>Para utilizar o LocaSmart Pro, você deve:</p>
          <ul>
            <li>Ter pelo menos 18 anos de idade.</li>
            <li>Fornecer informações verdadeiras, completas e atualizadas durante o cadastro.</li>
            <li>Ser legalmente capaz de celebrar contratos vinculantes.</li>
            <li>Cumprir todas as leis aplicáveis ao uso da plataforma.</li>
          </ul>

          <h2>4. Cadastro e Segurança da Conta</h2>
          <ul>
            <li><strong>Cadastro</strong>: Você deve criar uma conta fornecendo informações precisas, como nome, e-mail, documento (CPF/CNPJ), telefone e senha. Você é responsável por manter a confidencialidade de suas credenciais de acesso.</li>
            <li><strong>Segurança</strong>: Você é responsável por todas as atividades realizadas em sua conta. Notifique-nos imediatamente em caso de uso não autorizado ou violação de segurança.</li>
            <li><strong>Veracidade</strong>: Fornecer informações falsas ou incompletas pode resultar na suspensão ou encerramento da sua conta.</li>
          </ul>

          <h2>5. Uso Permitido</h2>
          <p>Você concorda em usar o LocaSmart Pro apenas para os fins previstos e de acordo com estes termos. Você não deve:</p>
          <ul>
            <li>Utilizar a plataforma para atividades ilegais ou não autorizadas.</li>
            <li>Tentar acessar, modificar ou interferir nos sistemas, servidores ou redes do LocaSmart Pro sem autorização.</li>
            <li>Violar direitos de propriedade intelectual de terceiros ou do LocaSmart Pro.</li>
            <li>Usar a plataforma para enviar spam, malware ou qualquer conteúdo prejudicial.</li>
          </ul>

          <h2>6. Propriedade Intelectual</h2>
          <p>Todo o conteúdo da plataforma, incluindo software, design, logotipos, textos e funcionalidades, é propriedade do LocaSmart Pro ou de seus licenciadores e está protegido por leis de direitos autorais e propriedade intelectual. Você não pode copiar, modificar, distribuir ou criar trabalhos derivados sem nossa autorização expressa.</p>

          <h2>7. Pagamentos e Assinaturas</h2>
          <ul>
            <li>Alguns recursos do LocaSmart Pro podem exigir pagamento. Detalhes sobre preços e planos estão disponíveis em nosso site.</li>
            <li>Você é responsável por todos os impostos e taxas aplicáveis ao uso da plataforma.</li>
            <li>Não oferecemos reembolsos, salvo disposição em contrário em nossa política de reembolso.</li>
          </ul>

          <h2>8. Limitação de Responsabilidade</h2>
          <ul>
            <li>O LocaSmart Pro é fornecido "no estado em que se encontra". Não garantimos que a plataforma será ininterrupta, livre de erros ou adequada a todas as suas necessidades.</li>
            <li>Não nos responsabilizamos por danos diretos, indiretos, incidentais ou consequenciais decorrentes do uso ou incapacidade de uso da plataforma, salvo nos casos exigidos por lei.</li>
            <li>Você é responsável por manter backups de seus dados. Não nos responsabilizamos por perda de dados devido a falhas técnicas ou outros motivos.</li>
          </ul>

          <h2>9. Rescisão</h2>
          <ul>
            <li>Podemos suspender ou encerrar sua conta a qualquer momento, com ou sem aviso prévio, se você violar estes Termos de Uso ou se determinarmos que seu uso da plataforma é prejudicial.</li>
            <li>Você pode encerrar sua conta a qualquer momento, sujeito às condições de nossa política de cancelamento.</li>
          </ul>

          <h2>10. Alterações nos Termos</h2>
          <p>Podemos atualizar estes Termos de Uso periodicamente. Notificaremos você sobre alterações significativas por e-mail ou por meio da plataforma. O uso continuado da plataforma após tais alterações constitui aceitação dos novos termos.</p>

          <h2>11. Lei Aplicável</h2>
          <p>Estes Termos de Uso são regidos pelas leis do Brasil. Qualquer disputa relacionada a estes termos será resolvida nos tribunais competentes da cidade de São Paulo, SP, salvo disposição legal em contrário.</p>

          <h2>12. Contato</h2>
          <p>Se você tiver dúvidas ou preocupações sobre estes Termos de Uso, entre em contato conosco:</p>
          <ul>
            <li><strong>E-mail</strong>: locasmartpro@gmail.com</li>
            <li><strong>Telefone</strong>: +55 (85) 9149-1356</li>
          </ul>

          <p>Ao marcar a caixa "Eu aceito os Termos de Uso" durante o cadastro, você confirma que leu e concorda com estes termos. Agradecemos por escolher o LocaSmart Pro!</p>
        </TermosContainer>
      </LocaSmartLayout></> : <>
        <TermosContainer>
          <h1>Termos de Uso - LocaSmart Pro</h1>
          <p><strong>Última atualização: 26 de abril de 2025</strong></p>
          <p>Bem-vindo ao LocaSmart Pro, uma plataforma de gerenciamento inteligente de locações de veículos. Ao utilizar nossos serviços, você concorda em cumprir e estar vinculado aos seguintes Termos de Uso. Leia atentamente antes de se cadastrar ou utilizar a plataforma.</p>

          <h2>1. Aceitação dos Termos</h2>
          <p>Ao acessar ou utilizar o LocaSmart Pro, você declara que leu, entendeu e concorda em cumprir estes Termos de Uso, bem como nossa Política de Privacidade. Se você não concordar com qualquer parte destes termos, não poderá utilizar nossos serviços.</p>

          <h2>2. Descrição do Serviço</h2>
          <p>O LocaSmart Pro é uma plataforma que oferece ferramentas para gerenciamento de locações de veículos, incluindo cadastro de clientes, controle de contratos, faturamento e relatórios. O serviço é destinado a empresas e indivíduos que gerenciam locações de veículos, sujeito às condições aqui estabelecidas.</p>

          <h2>3. Elegibilidade</h2>
          <p>Para utilizar o LocaSmart Pro, você deve:</p>
          <ul>
            <li>Ter pelo menos 18 anos de idade.</li>
            <li>Fornecer informações verdadeiras, completas e atualizadas durante o cadastro.</li>
            <li>Ser legalmente capaz de celebrar contratos vinculantes.</li>
            <li>Cumprir todas as leis aplicáveis ao uso da plataforma.</li>
          </ul>

          <h2>4. Cadastro e Segurança da Conta</h2>
          <ul>
            <li><strong>Cadastro</strong>: Você deve criar uma conta fornecendo informações precisas, como nome, e-mail, documento (CPF/CNPJ), telefone e senha. Você é responsável por manter a confidencialidade de suas credenciais de acesso.</li>
            <li><strong>Segurança</strong>: Você é responsável por todas as atividades realizadas em sua conta. Notifique-nos imediatamente em caso de uso não autorizado ou violação de segurança.</li>
            <li><strong>Veracidade</strong>: Fornecer informações falsas ou incompletas pode resultar na suspensão ou encerramento da sua conta.</li>
          </ul>

          <h2>5. Uso Permitido</h2>
          <p>Você concorda em usar o LocaSmart Pro apenas para os fins previstos e de acordo com estes termos. Você não deve:</p>
          <ul>
            <li>Utilizar a plataforma para atividades ilegais ou não autorizadas.</li>
            <li>Tentar acessar, modificar ou interferir nos sistemas, servidores ou redes do LocaSmart Pro sem autorização.</li>
            <li>Violar direitos de propriedade intelectual de terceiros ou do LocaSmart Pro.</li>
            <li>Usar a plataforma para enviar spam, malware ou qualquer conteúdo prejudicial.</li>
          </ul>

          <h2>6. Propriedade Intelectual</h2>
          <p>Todo o conteúdo da plataforma, incluindo software, design, logotipos, textos e funcionalidades, é propriedade do LocaSmart Pro ou de seus licenciadores e está protegido por leis de direitos autorais e propriedade intelectual. Você não pode copiar, modificar, distribuir ou criar trabalhos derivados sem nossa autorização expressa.</p>

          <h2>7. Pagamentos e Assinaturas</h2>
          <ul>
            <li>Alguns recursos do LocaSmart Pro podem exigir pagamento. Detalhes sobre preços e planos estão disponíveis em nosso site.</li>
            <li>Você é responsável por todos os impostos e taxas aplicáveis ao uso da plataforma.</li>
            <li>Não oferecemos reembolsos, salvo disposição em contrário em nossa política de reembolso.</li>
          </ul>

          <h2>8. Limitação de Responsabilidade</h2>
          <ul>
            <li>O LocaSmart Pro é fornecido "no estado em que se encontra". Não garantimos que a plataforma será ininterrupta, livre de erros ou adequada a todas as suas necessidades.</li>
            <li>Não nos responsabilizamos por danos diretos, indiretos, incidentais ou consequenciais decorrentes do uso ou incapacidade de uso da plataforma, salvo nos casos exigidos por lei.</li>
            <li>Você é responsável por manter backups de seus dados. Não nos responsabilizamos por perda de dados devido a falhas técnicas ou outros motivos.</li>
          </ul>

          <h2>9. Rescisão</h2>
          <ul>
            <li>Podemos suspender ou encerrar sua conta a qualquer momento, com ou sem aviso prévio, se você violar estes Termos de Uso ou se determinarmos que seu uso da plataforma é prejudicial.</li>
            <li>Você pode encerrar sua conta a qualquer momento, sujeito às condições de nossa política de cancelamento.</li>
          </ul>

          <h2>10. Alterações nos Termos</h2>
          <p>Podemos atualizar estes Termos de Uso periodicamente. Notificaremos você sobre alterações significativas por e-mail ou por meio da plataforma. O uso continuado da plataforma após tais alterações constitui aceitação dos novos termos.</p>

          <h2>11. Lei Aplicável</h2>
          <p>Estes Termos de Uso são regidos pelas leis do Brasil. Qualquer disputa relacionada a estes termos será resolvida nos tribunais competentes da cidade de Fortaleza, CE, salvo disposição legal em contrário.</p>

          <h2>12. Contato</h2>
          <p>Se você tiver dúvidas ou preocupações sobre estes Termos de Uso, entre em contato conosco:</p>
          <ul>
            <li><strong>E-mail</strong>: locasmartpro@gmail.com</li>
            <li><strong>Telefone</strong>: +55 (85) 9149-1356</li>
          </ul>

          <p>Ao marcar a caixa "Eu aceito os Termos de Uso" durante o cadastro, você confirma que leu e concorda com estes termos. Agradecemos por escolher o LocaSmart Pro!</p>
        </TermosContainer>
      </>

  );
}

export default TermosDeUso;